import createSpeechRecognitionPonyfill, {
  createSpeechRecognitionPonyfillFromRecognizer
} from './SpeechToText/createSpeechRecognitionPonyfill';

export default createSpeechRecognitionPonyfill;

export { createSpeechRecognitionPonyfillFromRecognizer };
